// removed by extract-text-webpack-plugin
module.exports = {"root":"_3FYwv","title":"_2ey6d","row":"_p-dVG","header":"_33ZSK","name":"_36m7U","cell":"_3c7Vm","icon":"_2KUU9","win":"_18y91"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/ProductCompare/ProductCompare.scss
// module id = 1360
// module chunks = 3